// ⚠️ SOSTITUISCI con recensioni REALI dei tuoi clienti (es. Google Reviews).
// I dati qui sotto sono ESEMPI da rimpiazzare prima del lancio.

export const REVIEWS = [
  {
    name: "Marco B.",
    city: "Parma",
    service: "Apertura porta blindata",
    rating: 5,
    date: "Novembre 2025",
    text: "Chiamati alle 23, sono arrivati in 35 minuti. Hanno aperto la porta senza rovinarla e il prezzo è stato esattamente quello concordato al telefono. Consigliatissimi.",
  },
  {
    name: "Elisa M.",
    city: "Modena",
    service: "Spurgo scarico cucina",
    rating: 5,
    date: "Ottobre 2025",
    text: "Scarico completamente otturato la domenica mattina. In un'ora erano già qui con la videoispezione. Lavoro pulito e fattura chiara.",
  },
  {
    name: "Andrea R.",
    city: "Piacenza",
    service: "Guasto elettrico",
    rating: 5,
    date: "Settembre 2025",
    text: "Era saltata tutta la corrente per un cortocircuito. Hanno trovato il guasto in pochi minuti e ripristinato tutto. Tecnico molto competente e gentile.",
  },
  {
    name: "Giulia F.",
    city: "Parma",
    service: "Ricerca perdita",
    rating: 5,
    date: "Settembre 2025",
    text: "Avevo una perdita sotto il pavimento. Con la termocamera l'hanno individuata subito, senza demolire tutto come temevo. Servizio professionale.",
  },
  {
    name: "Stefano T.",
    city: "Modena",
    service: "Sostituzione serratura",
    rating: 5,
    date: "Agosto 2025",
    text: "Serratura europea sostituita in mezz'ora. Mi hanno spiegato tutto prima di iniziare, preventivo rispettato al centesimo.",
  },
  {
    name: "Sara D.",
    city: "Piacenza",
    service: "Idraulico urgente",
    rating: 5,
    date: "Luglio 2025",
    text: "Perdita dal rubinetto in piena notte. Risposto subito al WhatsApp, arrivati prima del previsto. Ottimo rapporto qualità-prezzo.",
  },
];

export const REVIEWS_SUMMARY = {
  averageRating: 4.9,
  totalReviews: 187,
};
